"use client";

import { useState } from "react";
import Reveal from "@/components/Reveal";

import { money } from "@/lib/money";

// Section filter: "All" renders everything (default, so crawlers and
// no-JS visitors get the full menu); picking a section shows just that one.
// Grouped menus (e.g. the festival's Land and Sea / Ground menus): sections carry `group`, and the
// page shows each group as a heading with its courses nested underneath; tabs switch between groups.
export default function MenuSections({ sections }) {
  const [active, setActive] = useState("All");
  const groups = [...new Set(sections.map((s) => s.group).filter(Boolean))];
  const grouped = groups.length > 0;
  const tabs = grouped ? groups : sections.map((s) => s.name);
  const showTabs = tabs.length > 2 || (grouped && tabs.length > 1);
  const shown =
    active === "All" ? sections : sections.filter((s) => (grouped ? s.group : s.name) === active);

  return (
    <>
      {showTabs && (
        <>
          {/* Desktop: pill buttons */}
          <nav className="section-tabs" aria-label="Menu sections">
            <button
              className={active === "All" ? "active" : ""}
              onClick={() => setActive("All")}
            >
              All
            </button>
            {tabs.map((t) => (
              <button
                key={t}
                className={active === t ? "active" : ""}
                onClick={() => setActive(t)}
              >
                {t}
              </button>
            ))}
          </nav>
          {/* Mobile: one-tap native dropdown instead of a swipe row */}
          <div className="section-select">
            <label>
              <span>Jump to a section</span>
              <select
                value={active}
                onChange={(e) => setActive(e.target.value)}
                aria-label="Menu sections"
              >
                <option value="All">Full menu</option>
                {tabs.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </label>
          </div>
        </>
      )}

      {shown.map((s, i) => (
        <Reveal key={`${s.group || ""}-${s.name}`} className="mt-3">
          {grouped && s.group !== shown[i - 1]?.group && (
            <div className="menu-group-head">
              <h2 className="menu-group-title">{s.group}</h2>
              {s.groupNote && <p className="menu-section-note">{s.groupNote}</p>}
            </div>
          )}
          {grouped ? <h3 className="menu-section-title menu-section-title--sub">{s.name}</h3> : <h2 className="menu-section-title">{s.name}</h2>}
          {s.note && <p className="menu-section-note">{s.note}</p>}
          <div className="dish-grid">
            {s.dishes.map((d, i) => (
              <div className="dish" key={`${d.name}-${i}`}>
                <div className="dish-head">
                  <span className="dish-name">{d.name}</span>
                  <span className="dish-dots" />
                  {d.price && <span className="dish-price">{d.price.startsWith("+") ? `+£${money(d.price.slice(1))}` : `£${money(d.price)}`}</span>}
                </div>
                {d.desc && <p>{d.desc}</p>}
                {d.tags?.length > 0 && (
                  <span className="dish-tags">{d.tags.join(" · ")}</span>
                )}
              </div>
            ))}
          </div>
        </Reveal>
      ))}
    </>
  );
}
